import { ReviewTalentsUI } from 'features'

const ReviewTalents = () => {
  return (
    <div>
      <ReviewTalentsUI/>
    </div>
  )
}

export { ReviewTalents }
